import * as models from '../';

export enum ContactStatus {
    Active = 'Active',
    Inactive = 'Inactive',
    All = 'All',
}

export enum LoginStatus {
    All = 'All',
    None = 'None',
    Active = 'Active',
    InActive = 'InActive',
}

export interface ContactsRequest extends models.RequestBase {
    firstName?: string; 
    lastName?: string; 
    email?: string;
    type: string;
    companyName: string;  
    status: ContactStatus; 
    xnAddress?: string;
    loginStatus: LoginStatus;
    connectId?: number; 
}

export const defaultContactsRequest: ContactsRequest = {
    pageNo: 1, 
    pageSize: 20, 
    type: '',
    companyName: '',
    status: ContactStatus.Active,    
    loginStatus: LoginStatus.All,
}